import {SectionOne, SectionTwo } from "../components/feature/Products";

export default function Products()
{
    return(
        <section className="">
            <SectionOne/>
            <SectionTwo/>
        </section>
    );
}